import React from 'react'

import { useNavigate } from 'react-router-dom';
import { useCompleteSignIn, useUpdateAccountDetails } from "../../hooks/authhooks";

// import { ResourceCardProps } from "../../data/types";
import StarRating from './StarRating';

import { ReactComponent as HeartIcon } from "../../icons/HeartIcon.svg";
import { ReactComponent as HeartOutlineIcon } from "../../icons/HeartOutlineIcon.svg";
import { ReactComponent as LocationIcon } from "../../icons/locationIcon.svg";

import { capitalizeString, getEmailFromAccessToken, getDirectLinkFromGoogleDriveSharedLink, getActionButtonLabel, getUIDFromAccessToken } from '../../utils/helpers';
import { ResourceSchema, ResourceType, SearchFilterOptionType } from '../../data/types';
import { useLoadCurrentResource } from '../../hooks/apphooks';


type ResourceCardProps = {
  resource: ResourceSchema;
  resourceIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  resourceType: ResourceType
  searchFilterOptions?: SearchFilterOptionType
  isMobile?: boolean
  isModal?: boolean
  toggleApplyModal: React.Dispatch<React.SetStateAction<ResourceType | undefined>>
  setApplyResource: React.Dispatch<React.SetStateAction<ResourceSchema>>
  // allMemberships: MembershipSchema[]
}

const ResourceCard: React.FC<ResourceCardProps> = ({isMobile, isModal, resourceType, resource, searchFilterOptions, resourceIcon: ResourceIcon, toggleApplyModal, setApplyResource}) => {
    // const [showLogo, updateShowLogo] = useState(true) 
    const navigate = useNavigate();

    const { getSavedResourceTruths } = useCompleteSignIn()
    const savedResources = getSavedResourceTruths()
    const setSignInModalIsOpen =  searchFilterOptions?.setSignInModalIsOpen
  
    // console.log("savedResources", savedResources)


    const getBgColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).bgColor : "#bbb"
      return '#fff'
    }

    const getPrimaryTextColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).primaryTextColor : "#202124"
      return '#202124'
    }

    const getSecondaryTextColor  = () => {
      // let memberStatus = findObjectByAttribute(memberships, "community_id", community?.id)?.status
      // return memberStatus ? getMembershipStatusColor(memberStatus).secondaryTextColor : "#696969"
      return '#696969'
    }

    const { currentResource } = useLoadCurrentResource(resource.id ? resource.id : "")
    resource = currentResource ? currentResource : resource

    const handleCardClick = async () => {
      if (resourceType && resource?.id){
        navigate(`/${resourceType}/${resource.id}`)
      }
    }

    const openInNewTab = (url: string) => {
      if (url){
        window.open(url, "_blank");
      }
    };

    const loggedinUsername = getEmailFromAccessToken(localStorage.getItem('accessToken'))
    const loggedinUid = getUIDFromAccessToken(localStorage.getItem('accessToken'))

    const { saveResource, removeResource } = useUpdateAccountDetails(loggedinUid)

    const handleSaveResource = () => {
      if (resource && resource.id){
        if (!loggedinUsername && setSignInModalIsOpen){
          setSignInModalIsOpen(true)
        } else if (loggedinUsername) {
          saveResource(resource.id)
        }
      }
    }
  
    const handleRemoveSavedResource = () => {
      if (resource && resource.id){
        removeResource(resource.id)
      }
    }

    var actionButtonLabel = getActionButtonLabel(resourceType)

    // Helper function to format address without duplication
    const formatAddress = (resource: ResourceSchema): string => {
      if (!resource) return ''
      
      const address = resource.address
      const city = resource.city
      const state = resource.state
      const zipcode = resource.zipcode
      
      // Check if we have complete address components
      const hasCompleteAddress = address && city && state && zipcode
      
      if (!hasCompleteAddress) {
        return 'Nationwide'
      }
      
      // Check if address already contains city/state to avoid duplication
      const addressLower = address.toLowerCase()
      const cityLower = city.toLowerCase()
      const stateLower = state.toLowerCase()
      
      // If address already contains city or state, don't duplicate
      const addressContainsCity = addressLower.includes(cityLower)
      const addressContainsState = addressLower.includes(stateLower)
      
      let addressParts: string[] = []
      
      // Add address if it doesn't already contain city/state
      if (!addressContainsCity && !addressContainsState) {
        addressParts.push(address)
      } else {
        // If address contains city/state, use it as-is but clean it up
        addressParts.push(address.trim().replace(/,\s*$/, ''))
      }
      
      // Add city if not already in address
      if (!addressContainsCity) {
        addressParts.push(city)
      }
      
      // Add state if not already in address
      if (!addressContainsState) {
        addressParts.push(state)
      }
      
      // Add zipcode
      addressParts.push(zipcode)
      
      return addressParts.join(', ')
    }

    if (isMobile){
      return (
          <div  className={`flex flex-col min-h-[200px] object-cover rounded-xl border-[1px] border-[#E9E9E9] w-[360px] mx-auto shadow-sm items-center text-start p-4 bg-gradient-to-a hover:bg-gradient-to-b from-[#f9f9f9] mt-5`} 
                style={{backgroundColor: getBgColor(), opacity: 0.9}} 
          >

            <div className='flex flex-row '>
              {
                resource.active && (<div className='flex my-2 w-[86px] rounded-2xl bg-[#E7F5EC]'>
                  <p className='m-auto text-[#0F973D] text-[14px] font-raleway font-normal'>Available</p>
                </div>)
              }
            </div>

              <div className='flex flex-col m-2 w-full'>
                <div className='flex flex-row'>
                  <div className='p-2 border-[#E9E9E9] w-16 border-[1px] rounded-md mr-auto my-2'>
                    {
                      getDirectLinkFromGoogleDriveSharedLink(resource?.logo) ? (
                        <img className=' h-10 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(resource.logo)} alt={resource?.id} /> 
                        ) : (
                          <ResourceIcon className={'relative m-1 w-10 aspect-square p-1 text-[#5DB6CE]/60 '} />
                          )
                    }
                  </div>
                  <div className='flex border-[1px] border-[#E9E9E9] text-[14px] h-[44px] ml-auto rounded-xl text-primaryDark-0'>
                  {
                    (savedResources && resource && resource?.id && !savedResources[resource.id])? (
                      <div className='flex flex-row text-black px-3 cursor-pointer' onClick={handleSaveResource}>
                        <HeartOutlineIcon className='text-black w-[16px] h-[15px] my-auto' />
                        <p className='mx-2 my-auto'>Save</p>
                      </div>
                    ) : (
                      <div className='flex flex-row text-primaryDark-400 px-3 cursor-pointer' onClick={handleRemoveSavedResource}>
                        <HeartIcon className='text-primaryDark-400 w-[16px] h-[15px] my-auto' />
                        <p className='mx-2 my-auto'>Saved</p>
                      </div>
                    )
                  }
                  </div>
                </div>
                  <p 
                    className='font-raleway font-semibold px-2 text-[18px] my-1 text-primaryDark-0 '
                  >
                    {resource.name}
                  </p>
                  <p className='px-2 font-raleway text-[14px] flex flex-row flex-wrap pt-1 text-[#8A8A8A] mb-4 min-w-0'>
                    <LocationIcon className="mr-1 mt-[1px] w-[16px] h-[16px] text-gray flex-shrink-0" />
                    <span className="break-words overflow-hidden line-clamp-2">{formatAddress(resource)}</span>
                  </p>
              </div>
           
              <button 
                onClick={() => openInNewTab(resource?.website ? resource.website : '')}
                className={`text-primaryDark-0 bg-white text-[14px] h-[51px] rounded-lg font-semibold border-[1px] border-[#E9E9E9] w-full mb-3 'h-auto'}`}
              >
                Visit Website
              </button>

              <button onClick={handleCardClick} className={`text-white bg-primaryDark-0 text-[14px] h-[51px] rounded-lg font-semibold border-0 w-full mb-3 ${(resource?.name && resource.name?.length <= 35) ? 'h-[51px]': 'h-auto'}`}>
                View {capitalizeString(resource.name ? resource.name : resourceType)}
              </button>
              {
                  (resource && resource.active && actionButtonLabel) ? (
                    <button 
                      onClick={()=> {
                        if (!loggedinUsername && setSignInModalIsOpen !== undefined){
                            setSignInModalIsOpen(true)
                        } else {
                          toggleApplyModal(resourceType)
                          setApplyResource(resource)
                        }
                        

                      }} 
                      className={`text-white rounded-md bg-primaryDark-300 text-[14px] h-[51px] font-bold border-0 w-full mb-3}`}>
                        {actionButtonLabel}
                    </button>
                  ) : (
                    <></>
                  )
                }
          </div>
          )
    } else {
      return (
        <div className={`flex flex-col ${resource.active ? 'min-h-[140px] ' : 'min-h-[120px] sm:min-h-[112px]'} ${isModal ? 'w-full' : 'w-[1152px]'} object-cover rounded-xl border-0 mx-auto my-auto shadow-sm  text-start p-4 bg-gradient-to-a hover:bg-gradient-to-b from-[#f9f9f9] mt-5`} 
            style={{backgroundColor: getBgColor(), opacity: 0.9}} 
        >
            <div className='flex flex-row '>
              {
                resource.active && (<div className='flex my-2 w-[86px] rounded-2xl bg-[#E7F5EC]'>
                  <p className='m-auto text-[#0F973D] text-[14px] font-raleway font-normal'>Available</p>
                </div>)
              }
            </div>

            <div className='flex flex-row min-w-0 overflow-x-hidden'>
              <div className='p-2 border-[#E9E9E9] w-16 border-[1px] rounded-md my-auto flex-shrink-0'>
                {
                  getDirectLinkFromGoogleDriveSharedLink(resource?.logo) ? (
                    <img className=' h-10 aspect-auto object-contain' src={getDirectLinkFromGoogleDriveSharedLink(resource.logo)} alt={resource?.id} /> 
                    ) : (
                      <ResourceIcon className={'relative m-1 w-10 aspect-square p-1 text-[#5DB6CE]/60 '} />
                      )
                }
              </div>

              <div className='flex flex-col flex-1 m-2 min-w-0'>
                  <span 
                    className='flex flex-row font-open-sans font-semibold px-2 text-sm sm:text-md'
                    style={{color: getPrimaryTextColor()}}
                  >
                    {resource.name}
                    {
                      resource?.rating ? (
                        <div className='flex flex-row flex-start mx-2 my-auto'>
                          <StarRating review_rating={resource.rating} />
                        </div>
                      ) : (<></>)
                    }
                  </span>
                  <div className='px-2 font-open-sans text-xs sm:text-sm flex flex-row items-start pt-1 min-w-0' style={{color: getSecondaryTextColor(), opacity: 0.8}}>
                    <LocationIcon className="mr-1 w-[16px] h-[16px] text-gray flex-shrink-0 mt-[2px]" />
                    <span className="break-words min-w-0 flex-1">{formatAddress(resource)}</span>
                  </div>

              </div>
              <div className="flex flex-row gap-2 ml-auto flex-shrink-0">
                {
                  (savedResources && resource && resource?.id && !savedResources[resource.id])? (
                    <div className='flex flex-row text-black px-3 cursor-pointer' onClick={handleSaveResource}>
                      <HeartOutlineIcon className='text-black w-[16px] h-[15px] my-auto' />
                      <p className='mx-2 my-auto'>Save</p>
                    </div>
                  ) : (
                    <div className='flex flex-row text-primaryDark-400 px-3 cursor-pointer' onClick={handleRemoveSavedResource}>
                      <HeartIcon className='text-primaryDark-400 w-[16px] h-[15px] my-auto' />
                      <p className='mx-2 my-auto'>Saved</p>
                    </div>
                  )
                }
                <button 
                  onClick={handleCardClick} 
                  className="text-primaryDark-0 hover:bg-gray-100 font-semibold border-[1px] border-[#E9E9E9] w-[146px] h-auto my-auto rounded-md"
                >
                  View {capitalizeString(resourceType)}
                </button>
               
                {
                  (resource && resource.active && actionButtonLabel && !isModal) ? (
                    <button 
                      onClick={()=> {
                        if (!loggedinUsername && setSignInModalIsOpen !== undefined){
                            setSignInModalIsOpen(true)
                        } else {
                          toggleApplyModal(resourceType)
                          setApplyResource(resource)
                        }
                      }} 
                      className="text-white rounded-md font-semibold bg-primaryDark-0 w-[146px] h-auto my-auto">
                        {actionButtonLabel}
                    </button>
                  ) : (
                    <></>
                  )
                }
              </div>
            </div>
        </div>
      )
    }



  }




export default ResourceCard
